import { useEffect, useState } from "react"
import { getCookie } from "../helpers/cookies.js"
import { api } from "../services/api/index.js"
import { Marca } from "./Marca.js"
import { r, Texto } from "./Texto.js"
/* ------- funciones utiles ------- */

const esTexto = (x) => typeof x === "string",
  isFake = (marca) => marca.hasOwnProperty("_fake_id")

const sanatize = (xs) =>
  xs.reduce((acc, curr) => {
    const ultimo = acc.length > 0 ? acc[acc.length - 1] : null
    return esTexto(ultimo) && esTexto(curr)
      ? acc.slice(0, -1).concat(ultimo + curr)
      : acc.concat(curr)
  }, [])

//Metodo que me da la lista de marcas viejas y nuevas, por separado.
const getMarcas = (marcas) => {
  var count = 0
  return marcas.reduce(
    ([new_marcas, old_marcas], marca) => {
      if (marca.comienzo != null) {
        new_marcas.push([count, marca])
        count++
      } else {
        old_marcas.push([count, marca, new RegExp(r(marca.seleccion))])
        count++
      }
      return [new_marcas, old_marcas]
    },
    [[], []]
  )
}

const marcanizar = (texto, marcas) => {
  // construyo las old_marcas_regex solo cuando no tengo comienzo
  // eslint-disable-next-line
  //
  const result = getMarcas(marcas)
  const new_marcas = result[0],
    old_marcas_regex = result[1]

  const marcs = new_marcas.map((nmarca) => {
    return {
      index: nmarca[0],
      pos: nmarca[1].comienzo,
      len: nmarca[1].seleccion.length,
      marca: nmarca[1],
    }
  })

  var next_char_index = 0

  return (
    old_marcas_regex
      // le asocio a cada marca su indice y su posicion de ocurrencia
      .map((marca_tuple, mix) => {
        const match = marca_tuple[2].exec(texto)
        return match
          ? {
              index: marca_tuple[0],
              pos: match.index,
              len: marca_tuple[1].seleccion.length,
              marca: marca_tuple[1], //aca antes no estaba marca:
            }
          : null
      })
      // ignoro lo que no matchean
      .filter((x) => x !== null)
      .concat(marcs)
      // ordeno las marcas segun esta posicion
      .sort((a, b) => a.pos - b.pos)
      // me quedo solo con las marcas, ahora ordenadas
      // .map(tuple => tuple[1])
      // spliteo
      //TODO: este mecanismo hace que no pueda marcar substrings dentro
      //de una marca, hay que ver como podriamos cambiarlo
      .reduce(
        (acc, x) => {
          const alreadyDone = acc[0],
            remaining = acc[1],
            // all_text = acc[1],
            i = x.pos,
            f = i + x.len,
            clean = remaining.slice(0, i - next_char_index),
            rest = remaining.slice(f - next_char_index),
            done = alreadyDone.concat(clean, {
              ...x.marca,
              show: false,
            })
          console.log(i, "---", f, " rest: ", rest)
          next_char_index += x.len + clean.length
          return [done, rest]
        },
        [[], texto]
      )
      .reduce((p, n) => p.concat(n), [])
  )
}

export const Respuesta = ({ con_id, respuesta, editable = false }) => {
  const [elems, setElems] = useState([])

  useEffect(() => {
    const marcas = respuesta.marcas ? respuesta.marcas : []
    const new_elems = marcanizar(respuesta.contenido, marcas)
    setElems(new_elems)
  }, [respuesta])

  //el indice indica en que particion del texto se hizo la seleccion
  //elems son los elementos nuevos a insertar (la particion nueva dentro de lo que antes era solo un fragmento)
  const handleInsert = (ix) => (elems) =>
    setElems(
      (currents) =>
        currents
          .slice(0, ix)
          .concat(elems)
          .concat(currents.slice(ix + 1)),
      console.log({ ix }, { elems }, " desde handle insert"),
      elems.forEach((element) => {
        console.log(element)
      })
    )

  const handleDelete = (ix) => async () => {
    const marca = elems[ix],
      esLocal = isFake(marca)

    if (!esLocal) {
      // envio http DELETE
      const { url, opt } = api.consignas.respuestas.marcas.post({
        token: getCookie("jwt"),
        con_id: 1,
        res_id: respuesta.respuesta_id, // <--
        marca_id: marca.id,
      })
      try {
        const response = await fetch(url, opt)
        if (!response.ok) {
          console.error(
            `Error al eliminar: ${response.status} - ${response.statusText}`
          )
          alert(`No se pudo eliminar. Error ${response.status}`)
          return
        }
        console.log("Eliminación exitosa")
      } catch (error) {
        console.error("Error en la petición:", error)
        alert("Error en la petición")
      }
    }

    // lo elimino de los renderizados
    setElems((currents) => {
      const pre = currents.slice(0, ix),
        pos = currents.slice(ix + 1)

      return sanatize(pre.concat(marca.seleccion).concat(pos))
    })
  }

  const setData = (ix) => (callback) => {
    setElems((currents) => {
      const pre = currents.slice(0, ix),
        pos = currents.slice(ix + 1)

      return pre.concat(callback(currents[ix])).concat(pos)
    })
  }

  const handleSave = (ix) => async () => {
    const marca = elems[ix],
      esLocal = isFake(marca);

    const ok = marca.comentario.length * marca.correccion.length > 0

    if (!ok) {
      alert(
        "No se permite guardar marcas con campos vacios. " +
          "Rellena ambos campos antes de clickear 'Guardar'."
      )
      return
    }

    if (esLocal) {
      // elimino su _fake_id
      delete marca._fake_id
      const { url, opt } = api.consignas.respuestas.marcas.create({
        token: getCookie("jwt"),
        con_id: 1,
        res_id: respuesta.respuesta_id,
        marca,
      })
      const response = await fetch(url, opt),
        new_marca = await response.json()

      // actualizo los elementos
      setElems((currents) => {
        const pre = currents.slice(0, ix),
          pos = currents.slice(ix + 1)
        return pre.concat(new_marca).concat(pos)
      })
    } else {
      const { url, opt } = api.consignas.respuestas.marcas.update({
        token: getCookie("jwt"),
        con_id: 1,
        res_id: respuesta.respuesta_id,
        marca_id: marca.id,
        marca,
      })
      const response = await fetch(url, opt)

      const nueva_marca = await response.json()
      
      return nueva_marca
    }
  }
  var indice_actual = 0

  // console.log("ELEM",elems,"ELEM")

  return (
    <>
      <div className="row">
        <div className="resp">
          {elems.map((elem, ix) => {
            if (esTexto(elem)) {
              console.log("--", elem, "--", elem.length, "--")
              indice_actual += elem.length
              return (
                <Texto
                  key={ix}
                  contenido={elem}
                  editable={editable}
                  handleInsert={handleInsert(ix)}
                  index_comienzo_texto={indice_actual - elem.length}
                />
              )
            } else {
              indice_actual += elem.seleccion ? elem.seleccion.length : 0
              return (
                <Marca
                  key={ix}
                  marca={elem}
                  editable={editable}
                  setData={setData(ix)}
                  handleDelete={handleDelete(ix)}
                  handleSave={handleSave(ix)}
                />
              )
            }
          })}
          <div className="d-flex justify-content-between">
            <p className="date m-0 mt-2">
              <i>Enviado el {respuesta.timestamp.substring(0, 10)}</i>
            </p>
            {con_id && (
              <a
                type="button"
                rel="noreferrer"
                target="_blank"
                href={`${con_id}/respuestas/${respuesta.respuesta_id}`}
                className="btn btn-sm text-decoration-none">
                🔗
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
